// extracted by mini-css-extract-plugin
module.exports = {"fullWidthInputField":"DepartmentsFormModal_fullWidthInputField__193EZ"};